export interface GlpContinuationArticleConfig {
  translationKey: string;
  url: string;
  image: string;
}

export const GLP_CONTINUATION_ARTICLES: GlpContinuationArticleConfig[] = [
  {
    translationKey: "glpContinuation.articles.title_1",
    url: "https://join9am.com/blog/speeding-up-your-renewal",
    image:
      "https://cdn.sanity.io/images/g38rxyoc/production/1cff816a36c36c7efc234104e48ad3f1a4d65959-653x436.jpg"
  },
  {
    translationKey: "glpContinuation.articles.title_2",
    url: "https://join9am.com/blog/where-to-find-your-latest-prescription-information",
    image:
      "https://cdn.sanity.io/images/g38rxyoc/production/2c9c5491884d30bee78b947be75c7b084cd9df0d-4096x2731.jpg"
  },
  {
    translationKey: "glpContinuation.articles.title_3",
    url: "https://join9am.com/blog/where-to-find-your-weight-from-when-glp-1-was-first-prescribed",
    image:
      "https://cdn.sanity.io/images/g38rxyoc/production/e90da626b1fbae817fcfd35074e45b7a0f68b9e7-1920x1080.png"
  }
];
